export { default as crisp } from './kinds/Crisp';
export { default as crunch } from './kinds/Crunch';
export { default as slim } from './kinds/Slim';
export { default as fresh } from './kinds/Fresh';


// WEBPACK FOOTER //
// ./src/CinnamonSugar/index.js